import React, { useState, useEffect } from "react";
import RSheetsList from "./RSheetsList";
import { formatDate2, formatUTCtoPST, handleError } from "../../shared/utility";
import { statusDescriptions, typeDescriptions } from "./RSheetsLogic";
import { Tooltip } from "@material-ui/core";
import Button from "../../components/CustomButtons/Button";
import { Edit, ContentCopy, Close } from "@material-ui/icons";
import CustomMultipleSelect from "../../components/CustomSelect/CustomMultipleSelect";
import { TextField } from "@material-ui/core";
import moment from "moment-timezone";
import { Dialog } from "@material-ui/core";
import Loader from "components/Loader/Loader";
import axios from "store/axios/axios-rs";
import { getUser } from "../../shared/authValidation";
import { calculateTotalInvoicePicture } from "../Invoices/InvoiceLogic";
import EstimatedPaymentReportButton from "../PaymentReports/EstimatedPaymentReportButton";
import { INVOICE_STATUS } from "../Invoices/InvoiceObj";
import { calculatePercentForRsRow } from "./CommonCustomElements/PercentComplete";
export const RS_VIEW_FILTERS_MODULE = "rs";
export const RS_COLUMNS_META = [
    { accessor: 'id', Header: 'id #' },
    { accessor: 'illi_number', Header: 'illi #' },
    { accessor: 'project_name', Header: 'Project Name' },
    { accessor: 'unit_number', Header: 'Unit #' },
    { accessor: 'name', Header: 'Submitter' },
    { accessor: 'date_created_unix', Header: 'Date Created' },
    { accessor: 'title', Header: 'RS Type / Title' },
    { accessor: 'bill_to', Header: 'Bill To' },
    { accessor: 'percent_complete', Header: '% Complete' },
    { accessor: 'status', Header: 'Status' },
    { accessor: 'actions', Header: 'Actions' },
];

const RSheetsAllList = (props) => {
    const [rsTypeFilter, setRSTypeFilter] = useState([]);
    const [revisionStarted, setRevisionStarted] = useState(false);
    const [openedAsk, setOpenedAsk] = useState(null);
    const [notes, setNotes] = useState("");
    const hiddenColumns = Array.isArray(props.hiddenColumns) ? props.hiddenColumns : [];
    const [checkingInvoicePayments, setCheckingInvoicePayments] = useState(false);

    const saveRSAccessLog = async (rs_id) => {
        console.log('saving user log rs 1', rs_id);
        try {
            const user = getUser();
            await axios.post('/create_user_log', {
                user_id: user.id,
                rs_id
            });
            console.log('saving user log rs 2', rs_id);
        } catch(e) {
            handleError(e);
        }
    }

    console.log('openedAsk', openedAsk);

    const startCheckRSPaymentsInvoices = async (the_rs_id) => {
        setCheckingInvoicePayments(true);
        let found_invoices = false;
        let found_payments = false;
        const inv_data = await calculateTotalInvoicePicture(the_rs_id);
        if (inv_data) {
            const invoices = inv_data.invoices;
            if (invoices) {
                invoices.forEach(inv => {
                    if (inv.status !== INVOICE_STATUS.VOIDED) {
                        found_invoices = true;
                    }
                    if (inv.payments) {
                        if (inv.payments.length > 0) {
                            found_payments = true;
                        }
                    }
                })
            }
        }
        setCheckingInvoicePayments(false);
        console.log('inv_data', inv_data);
        if (found_invoices || found_payments) {
            return false;
        } else {
            return true;
        }
    }

    useEffect(() => {
        if (props.rsheetRevision && revisionStarted) {
            // go to drafts tab and "open revision ?"
            props.goToMyDrafts();
            props.setCurrentType(props.rsheetRevision.type);
            props.getRsheet(props.rsheetRevision.id);
            props.setViewOnly(false);
            props.setShowForm(true);
            props.setCurrentAction();
            setRevisionStarted(false);
        }
    }, [props.rsheetRevision]);
    const { list, tab, subFilter } = props;
    const isAllTab = tab === 'all';
    const subFilterValue = subFilter || 'all';
    const currentUser = getUser();
    const isApproverUser = currentUser && currentUser.permObj
        ? Object.keys(currentUser.permObj).some(p => p.toLowerCase().indexOf('routing approve') !== -1)
        : false;

    const matchesSubFilter = (l) => {
        if (!isAllTab || subFilterValue === 'all') return true;
        const s = l.status;
        const isOwn = l.user_id === currentUser.id;
        switch (subFilterValue) {
            case 'my_drafts': return [1, 5, 11].indexOf(s) !== -1 && isOwn;
            case 'user_drafts': return [1, 5, 11].indexOf(s) !== -1;
            case 'pending_my_drafts': return [2, 3, 4, 6, 7, 8, 10, 11].indexOf(s) !== -1;
            case 'pending_further_approval': return [3, 4, 10].indexOf(s) !== -1;
            case 'my_completed': return s === 9 && isOwn;
            case 'all_completed': return s === 9;
            case 'voided': return s === 0;
            case 'my_voided': return s === 0 && isOwn;
            default: return true;
        }
    };

    const finalList = list.filter((l) => {
        if (!matchesSubFilter(l)) return false;
        if (rsTypeFilter.length === 0) {
            return true;
        } else {
            const ltype = l.type.toString();
            if (rsTypeFilter.indexOf(ltype) !== -1) {
                return true;
            }
        }
        return rsTypeFilter.length === 0;
    });
    const close = () => {
        setOpenedAsk(null);
        setNotes("");
    };
    return (
        <div>
            <Dialog
                open={openedAsk ? true : false}
                onClose={() => {
                    close();
                }}
                width="sm"
                fullWidth={true}
                keepMounted
            >
                <div className="dialog-wrapper">
                    <div>
                        <span
                            className="close-btn"
                            onClick={() => {
                                close();
                            }}
                        >
                            <Close />
                        </span>
                    </div>
                    <div className="custom-textfield">
                        <TextField
                            label="Notes"
                            multiline
                            rowsMax="4"
                            value={notes}
                            onChange={(e) => {
                                setNotes(e.target.value);
                            }}
                            rows={4}
                            margin="normal"
                        />
                    </div>
                    {checkingInvoicePayments && <Loader />}
                    {!notes && <div className="red-text text-center">Please enter notes regarding this revision</div>}
                    <div className="text-center mt-20">
                        <Button
                            onClick={async () => {
                                const all_voided = await startCheckRSPaymentsInvoices(openedAsk.id);
                                if (all_voided) {
                                    props.setCurrentType(openedAsk.type);
                                    close();
                                    setRevisionStarted(true);
                                    props.createRsheetRevision({
                                        id: openedAsk.id,
                                        notes,
                                    });
                                    // record void history
                                    props.createRsHistory({
                                        json_data: openedAsk.json_data,
                                        rs_id: openedAsk.id,
                                        status: 0
                                    })
                                } else {
                                    alert('Cannot create routing sheet revision, please void all payments and invoices');
                                }
                            }}
                            disabled={notes ? false : true}
                            color="primary"
                            style={{ marginRight: 20 }}
                        >
                            CREATE REVISION
                        </Button>
                        <Button
                            color="white"
                            onClick={() => {
                                setOpenedAsk(null);
                                setNotes("");
                            }}
                        >
                            CANCEL
                        </Button>
                    </div>
                </div>
            </Dialog>

            {props.loadingEntries && <Loader center={true} />}

            {!props.loadingEntries && <RSheetsList
                hiddenColumns={hiddenColumns}
                data={finalList.map((l, i) => {
                    console.log('finalList entry', l, i+1);
                    const { type, illi_number } = l;
                    let prefixed_illi_number = illi_number;
                    // ALREADY HAS PREFIX SAVED
                    // if (type === 5) {
                    //     // Tenant Rep
                    //     prefixed_illi_number = "TR" + illi_number.toString();
                    // } else if (type === 8) {
                    //     // No Listing
                    //     prefixed_illi_number = "NL" + illi_number.toString();
                    // }

                    const rs_type = typeDescriptions[l.type] ? typeDescriptions[l.type] : "";
                    const bill_to = l.json_data ? 
                        l.json_data.billing_attention || l.json_data.billing_attention_lastname ?
                            `${l.json_data.billing_attention} ${l.json_data.billing_attention_lastname}`
                        : 
                            ''
                    :
                        '';

                    console.log('my current tab', tab)

                    const user = getUser();
                    const isOwn = l.user_id === user.id;
                    let rowTab = tab;
                    if (tab === 'all') {
                        if (l.status === 0) rowTab = isOwn ? 'my_voided' : 'voided';
                        else if (l.status === 9) rowTab = isOwn ? 'my_completed' : 'all_completed';
                        else if ([1, 5, 11].indexOf(l.status) !== -1) rowTab = isOwn ? 'my_drafts' : 'user_drafts';
                        else if ([3, 4, 10].indexOf(l.status) !== -1) rowTab = 'pending_further_approval';
                        else rowTab = 'pending_my_drafts';
                    }
                    const level_four_reviewer = user?.permObj?.['Routing approve level_4'] ?
                            rowTab === 'pending_further_approval' || rowTab === 'pending_my_drafts' ?
                                true
                            :
                                false
                        :
                            false;

                    return {
                        id: l.id,
                        name: l.name,
                        illi_number: prefixed_illi_number,
                        unit_number: l.json_data ? l.json_data.unit_number : '',
                        bill_to,
                        name: l.name,
                        project_name: l.project_name,
                        date_created_unix: moment(l.date_created.replace("T", " ")).unix(),
                        date_modified: formatUTCtoPST(l.date_modified),
                        rs_type,
                        title: l.title ? `${rs_type} - Revision ${l.title.split("_").length}` : rs_type,
                        status: statusDescriptions[l.status] ? statusDescriptions[l.status] : "",
                        percent_complete: calculatePercentForRsRow(l),
                        _rowTab: rowTab,
                        actions: (
                            <div>
                                <EstimatedPaymentReportButton rs_id={l.id} />
                                {(
                                    (rowTab !== "user_drafts" && rowTab !== "my_drafts"))
                                    &&
                                    <Tooltip title="View" placement="top">
                                        <Button
                                            justIcon
                                            round
                                            simple
                                            onClick={() => {
                                                if (isAllTab && props.setTab) props.setTab(rowTab);
                                                props.setCurrentType(l.type);
                                                props.getRsheet(l.id);
                                                props.setViewOnly(true);
                                                props.setShowForm(true);
                                                props.setCurrentAction();
                                                props.getRsInternalReviewers(l.id);
                                            }}
                                            color="primary"
                                            className="mr-20"
                                        >
                                            <i className="fas fa-eye font-22"></i>
                                        </Button>
                                    </Tooltip>
                                }
                                {/* Completed */}
                                {l.status === 9 && (
                                    <Tooltip title="Create Revision" placement="top">
                                        <Button
                                            justIcon
                                            round
                                            simple
                                            onClick={() => {
                                                setOpenedAsk(l);
                                            }}
                                            color="primary"
                                            className="mr-20"
                                        >
                                            <ContentCopy />
                                        </Button>
                                    </Tooltip>
                                )}
                                {(
                                  level_four_reviewer ||
                                  l.status === 1 ||
                                  l.status === 5 ||
                                  (rowTab === "pending_my_drafts" && l.status !== 11) ||
                                  (rowTab === 'my_drafts' && l.status === 11)
                                ) && (
                                    <Tooltip title="Edit" placement="top">
                                        <Button
                                            justIcon
                                            round
                                            simple
                                            onClick={() => {
                                                if (isAllTab && props.setTab) props.setTab(rowTab);
                                                props.setCurrentType(l.type);
                                                props.getRsheet(l.id);
                                                props.setViewOnly(false);
                                                props.setShowForm(true);
                                                props.setCurrentAction();
                                                props.getRsInternalReviewers(l.id);
                                                saveRSAccessLog(l.id);
                                            }}
                                            color="primary"
                                            className="mr-20"
                                        >
                                            <Edit />
                                        </Button>
                                    </Tooltip>
                                )}
                                {/* Delete is only for Pure Drafts */}
                                {l.status !== 9 && (
                                    <Tooltip title="Delete" placement="top">
                                        <Button
                                            justIcon
                                            round
                                            simple
                                            onClick={() => {
                                                props.setAskBeforeDelete({ id: l.id, status: l.status });
                                            }}
                                            color="primary"
                                            className="mr-20"
                                        >
                                            <i className="fas fa-trash font-22"></i>
                                        </Button>
                                    </Tooltip>
                                )}
                            </div>
                        ),
                    };
                })}
                columns={[
                    {
                        Header: "id #",
                        accessor: "id",
                        filterMethod: (filter, row) => {
                            if (filter.value) {
                                var filterValue = filter.value.toLowerCase();
                                if (filterValue.length > 0) {
                                    if (row.id) {
                                        if (row.id.toString().indexOf(filterValue) !== -1) {
                                            return true;
                                        }
                                    }
                                    return false;
                                } else {
                                    return true;
                                }
                            }
                        },
                        maxWidth: 40
                    },
                    {
                        Header: "illi #",
                        accessor: "illi_number",
                        filterMethod: (filter, row) => {
                            if (filter.value) {
                                var filterValue = filter.value.toLowerCase();
                                if (filterValue.length > 0) {
                                    if (row.illi_number) {
                                        if (row.illi_number.toString().toLowerCase().indexOf(filterValue) !== -1) {
                                            return true;
                                        }
                                    }
                                    return false;
                                } else {
                                    return true;
                                }
                            }
                        },
                    },
                    {
                        Header: "Project Name",
                        accessor: "project_name",
                        filterMethod: (filter, row, column) => {
                            const id = filter.pivotId || filter.id;
                            return row[id] ? String(row[id].toLowerCase()).indexOf(filter.value.toLowerCase()) !== -1 : true;
                        }
                    },
                    {
                        Header: "Unit #",
                        accessor: "unit_number",
                        filterMethod: (filter, row, column) => {
                            const id = filter.pivotId || filter.id;
                            return row[id] ? String(row[id].toLowerCase()).indexOf(filter.value.toLowerCase()) !== -1 : true;
                        },
                        maxWidth: 40
                    },
                    {
                        Header: "Submitter",
                        accessor: "name",
                        filterMethod: (filter, row, column) => {
                            const id = filter.pivotId || filter.id;
                            return row[id] ? String(row[id].toLowerCase()).indexOf(filter.value.toLowerCase()) !== -1 : true;
                        }
                    },
                    {
                        Header: "Date Created",
                        accessor: "date_created_unix",
                        Cell: (props) => {
                            return (
                                <div>
                                    {moment.unix(props.value).tz("America/Los_Angeles").format("MM/DD/YYYY h:mm a")}
                                </div>
                            );
                        },
                        filterMethod: (filter, row, column) => {
                            const id = filter.pivotId || filter.id;
                            if (row[id]) {
                                const formattedDate = moment.unix(row[id]).tz("America/Los_Angeles").format("MM/DD/YYYY h:mm a")
                                return formattedDate.toString().indexOf(filter.value.toLowerCase()) !== -1;
                            }
                            return false
                        }
                    },
                    {
                        Header: "RS Type / Title",
                        accessor: "title",
                        Filter: ({ column: { filterValue, setFilter } }) => {
                            return (
                                <CustomMultipleSelect
                                    options={Object.keys(typeDescriptions).map((type) => {
                                        return typeDescriptions[type];
                                    })}
                                    label=""
                                    choose={(e, n) => {
                                        const types = e.map((description) => {
                                            let type = 0;
                                            Object.keys(typeDescriptions).forEach((typed) => {
                                                if (typeDescriptions[typed] === description) {
                                                    type = typed;
                                                }
                                            });
                                            return type;
                                        });
                                        setRSTypeFilter(types);
                                    }}
                                    style={{margin: 0, padding: '5px'}}
                                    className="rs-list"
                                />
                            );
                        },
                        maxWidth: 80
                    },
                    {
                        Header: "Bill To",
                        accessor: "bill_to",
                        filterMethod: (filter, row, column) => {
                            const id = filter.pivotId || filter.id;
                            return row[id] ? String(row[id].toLowerCase()).indexOf(filter.value.toLowerCase()) !== -1 : true;
                        }
                    },
                    {
                        Header: "% Complete",
                        accessor: "percent_complete",
                        maxWidth: 100,
                        Cell: (cellProps) => `${cellProps.value}%`,
                        filterMethod: (filter, row) => {
                            if (!filter.value) return true;
                            return String(row.percent_complete).indexOf(filter.value) !== -1;
                        },
                        sortMethod: (a, b) => (a || 0) - (b || 0)
                    },
                    {
                        Header: "Status",
                        accessor: "status",
                    },
                    {
                        Header: "Actions",
                        accessor: "actions",
                    },
                ]}
                getTdProps={(state, rowInfo, column) => ({
                    onClick: (e, handleOriginal) => {
                        if (isAllTab && rowInfo && rowInfo.original && column.id !== 'actions' && props.setTab) {
                            props.setTab(rowInfo.original._rowTab);
                        }
                        if (handleOriginal) handleOriginal();
                    },
                    style: isAllTab && column.id !== 'actions' ? { cursor: 'pointer' } : {}
                })}
            />}
        </div>
    );
};

export default RSheetsAllList;
